import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "tab-name-edit"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = ["placeholder"];
var _hoisted_4 = {
  key: 0
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "recently-used"
}, "Recently used", -1);

var _hoisted_6 = {
  class: "recent-name-list"
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    width: "65%",
    top: "5vh"
  }, {
    title: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.editPen,
        iconStyle: "width: 30px; height: 30px;"
      }, null, 8, ["iconContent"]), _createElementVNode("h2", null, _toDisplayString(_ctx.$t("tabs.edit")), 1)]), _createVNode(_component_el_divider, {
        class: "mb-0"
      })];
    }),
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
        class: "py-5 px-6 cancel-btn",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.hideModal();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "py-5 px-6 save-btn",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.onSave();
        }),
        disabled: !_ctx.tabName
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.save")), 1)];
        }),
        _: 1
      }, 8, ["disabled"])])];
    }),
    default: _withCtx(function () {
      return [_withDirectives(_createElementVNode("input", {
        class: "tab-name-input",
        placeholder: _ctx.$t('input.edit-order-name'),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.tabName = $event;
        })
      }, null, 8, _hoisted_3), [[_vModelText, _ctx.tabName]]), _ctx.recentlyUsedNames.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("ul", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentlyUsedNames, function (name) {
        return _openBlock(), _createElementBlock("li", {
          key: name
        }, [_createElementVNode("h2", {
          class: "recent-name",
          onClick: function onClick($event) {
            return _ctx.updateNameInput(name);
          }
        }, _toDisplayString(name), 9, _hoisted_7), _createVNode(_component_el_divider)]);
      }), 128))])])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}